import React, { useState, useMemo } from "react";
import { TextField, Autocomplete } from "@mui/material";

export default function SingleSelectWithSearch({
  dropDownList,
  selectedValue,
  setSelectedValue,
  label = "Select One",
  placeholder = "Search...",
}) {
  const [searchText, setSearchText] = useState("");

  // Transform dropDownList object into an array of { key, value }
  const allOptions = useMemo(() => {
    return Object.entries(dropDownList || {}).map(([key, value]) => ({
      key,
      value,
    }));
  }, [dropDownList]);

  // Find the selected option object by matching value
  const selectedOptionObject = useMemo(() => {
    return allOptions.find((option) => option.value === selectedValue) || null;
  }, [selectedValue, allOptions]);

  // Filter options based on search text
  const filteredOptions = useMemo(() => {
    return allOptions
      .filter((option) =>
        option.key.toLowerCase().includes(searchText.toLowerCase())
      )
      .slice(0, 150); // limit for performance
  }, [allOptions, searchText]);

  return (
    <Autocomplete
      id="single-select-with-search"
      options={filteredOptions}
      value={selectedOptionObject}
      getOptionLabel={(option) => option?.key || ""}
      onInputChange={(event, newInputValue) => setSearchText(newInputValue)}
      onChange={(event, newSelectedOption) => {
        const selected = newSelectedOption ? newSelectedOption.value : "";
        setSelectedValue(selected);
      }}
      isOptionEqualToValue={(option, value) => option.value === value?.value}
      renderOption={(props, option) => (
        <li {...props} style={{ fontSize: "14px", color: "#333" }}>
          {option.key}
        </li>
      )}
      renderInput={(params) => (
        <TextField
          {...params}
          label={label}
          placeholder={placeholder}
          sx={{
            "& label.Mui-focused": {
              color: "#2d65c7",
            },
            "& .MuiOutlinedInput-root": {
              height: "50px",
              paddingTop: "0px",
              fontSize: "14px",
              "& .MuiAutocomplete-input": {
                height: "50px",
                paddingTop: "0px",
                fontSize: "14px",
              },
              "& fieldset": {
                borderColor: "#ccc",
                fontSize: "14px",
              },
              "&.Mui-focused fieldset": {
                borderColor: "#2d65c7",
              },
            },
          }}
        />
      )}
      style={{ width: "100%", height: "50px", fontSize: "14px" }}
    />
  );
}


